import { createResetStateMutation } from '@/helpers';
import { getInitialStateSiniestro } from './state';

export const SET_SEARCH_DATA = (state, formSearch) => {
   state.formSearch = formSearch;
};
export const SET_POLIZA_DENUNCIA = (state, rowData) => {
   state.polizaDenunciar = rowData;
};
export const setPolizas = (state, data) => {
   state.polizas = data;
};
export const setLotes = (state, data) => {
   state.lotes = data;
};

export const resetState = createResetStateMutation(getInitialStateSiniestro);
